
export const isMessageAlreadyInList = (listMessages, messageCode) => {
  let response = false
  if(!listMessages || !messageCode){
    return false
  }

  if(!Array.isArray(listMessages) || typeof messageCode !== "string"){
    return false
  }

  listMessages.forEach(message => {
    if(message?.code === messageCode){
      response = true
    }
  })

  return response
}